export {
  default as rollbar,
  getRollbarConfig,
  setRollbarUserInfo
} from "./rollbar";
